import { inject, Injectable } from '@angular/core';
import { DIALOG_BREAKPOINTS, SHARED_DIALOG_CONFIG } from '@pinnakl/shared/constants';
import { DialogService } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { ChangePasswordModalComponent } from '../modals/change-password-modal/change-password-modal.component';

@Injectable()
export class AuthPopupService {
  private readonly dialogService = inject(DialogService);

  openChangePasswordModal(): Promise<string | undefined> {
    return firstValueFrom(
      this.dialogService.open(ChangePasswordModalComponent, {
        ...SHARED_DIALOG_CONFIG,
        showHeader: true,
        header: 'Update password',
        width: '620px',
        breakpoints: DIALOG_BREAKPOINTS,
        focusOnShow: true,
        closable: false,
        closeOnEscape: false,
        dismissableMask: false,
      }).onClose,
    );
  }
}
